<template>
  <div v-drag  >
    <a-modal v-model:visible="dialogVisible"
             :bodyStyle="bodyStyle"
             :maskClosable="false"
             :closable="false"
             :footer="null"
             wrapClassName="my-modal-wrap"
             >
      <template #title>
        <div class="title">
          选择题目数量
        </div>
      </template>

      <a-form :labelCol="{span:8}"
      :model="questionForm"
              :wrapperCol="{span:10}">
        <a-form-item label="" style="display:flex;justify-content: center;"> 
            <a-input-number v-model:value="questionForm.question_num"
                           :min="1"
                           style="width: 100%;"
                           :max="10"
                              label=""></a-input-number>
        </a-form-item>
      
        
      </a-form>
      <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确认
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from "@vue/reactivity";
import { message } from "ant-design-vue";
import { topicPress } from '@/api/error.js'
import { useRouter } from 'vue-router'
const router = useRouter()
let dialogVisible = ref(false)
let questionForm = reactive({
  question_num:5
})
let knowledge_id = ref('')
const bodyStyle = {
  padding: "0 ", 
}

const save = async () => {
  console.log('form',questionForm )
  if (questionForm.question_num == '') {
    message.warning('请输入题目数量')
    return
  }

  let form = {
    question_num: questionForm.question_num,
    knowledge_id: knowledge_id.value
  }
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  router.push('/doPaper?isKnowledge=1&form=' + JSON.stringify(form))
  dialogVisible.value = false

  form.question_num = ''
  knowledge_id.value = ''
}


const handleClose = () => {
  dialogVisible.value = false
}


defineExpose({
  dialogVisible,knowledge_id, 

})
</script>

<style lang="scss" >
.my-modal-wrap {
.desction {
  font-size: 24rem;
  font-weight: bold;
  color: #ff6147;
}

.btn_warp {
  height: 70rem;
  border-top: 1px solid #e5e5e5;
  display: flex;
  // position: absolute;
  bottom: 0;
  width: 100%;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(1) {
      font-size: 24rem;
      font-weight: 400;
      color: #999999;
      border-right: 1px solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 24rem;
     font-weight: 400;
      color: #2196f3;
    }
  }
}
.ant-form {
  padding: 20rem;
}
:deep .ant-form-item-label > label {
  // font-size: 24rem;
  font-weight: 500;
  color: #333333;
}

:deep .ant-input {
  // font-size: 24rem;
  font-weight: 500;
  color: #999999;
}
.title {
  font-size: 28rem !important;
} 
 
 .ant-modal{
top: 35%;
}
  .ant-modal-content {
  border-radius: 32px;
 
}
.ant-input-number{
   font-size: 24rem
}
}
</style>